import { MAP_TYPE, MAP_TYPES } from '@helpers/Constants';
import { IMapPoint } from '../types';

export const getAmapLocation = async (
  position: IMapPoint,
): Promise<{ address: string; title: string }> => {
  return new Promise((resolve, reject) => {
    const geocoder: any = new AMap.Geocoder({
      radius: 1000, //以已知坐标为中心点，radius为半径，返回范围内兴趣点和道路信息
      extensions: 'all', //返回地址描述以及附近兴趣点和道路信息，默认“base”
    });
    geocoder.getAddress([position.lng, position.lat], function(
      status: string,
      result: any,
    ) {
      if (status === 'complete') {
        const { formattedAddress } = result?.regeocode;
        resolve({ address: formattedAddress, title: '' });
      } else {
        reject();
      }
    });
  });
};

export const getBmapLocation = async (
  position: IMapPoint,
): Promise<{ address: string; title: string }> => {
  const map = new BMap.Geocoder();
  return new Promise(resolve => {
    map.getLocation(new BMap.Point(position.lng, position.lat), function(
      res: any,
    ) {
      resolve({ address: res.address, title: res.title || '' });
    });
  });
};

//获取当前点击的坐标点
export const getCurrentClickPointInfo = (result: any) => {
  let point = null;
  switch (MAP_TYPE) {
    case MAP_TYPES.aMap:
      point = {
        lng: result?.lnglat?.lng,
        lat: result?.lnglat?.lat,
      };
      break;
    case MAP_TYPES.bMap:
      point = result?.point;
      break;
    //no default
  }
  return point;
};

export const sortDistanceData = (arr: any[]) => {
  if (arr.length <= 2) {
    return arr;
  }
  const list = arr.sort(function(a: any, b: any) {
    return a.distance - b.distance;
  });
  return list;
};
